import dotProp from 'dot-prop'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { actions as formActions } from 'react-redux-form'
import { Form, Label, TextArea } from 'semantic-ui-react'
import underscored from 'underscore.string/underscored'

import { ADDRESS_KEYS, formatAddress, mergeAddress, parseAddress } from 'components/superuser/billing/address'

const LABELS = {
  street: 'Street',
  houseNumber: 'No.',
  bus: 'Bus',
  postalCode: 'Postal code',
  city: 'City',
  country: 'Country'
}

// Canonical text for what the user typed, to tell "the user is typing" apart
// from "the stored value changed underneath us" (e.g. the entity finished loading).
const canonical = (text) => formatAddress(parseAddress(text).address)

// One paste box for an address hash: "street ; number ; bus ; postal code ; city ; country".
// The parsed result is shown underneath so a misplaced ';' is visible before saving.
// Like the other fields, the value lives in redux (react-redux-form), not in rjsf's formData.
function AddressPasteField ({ name, value, change, required, readonly, translationScope }) {
  const [text, setText] = useState(() => formatAddress(value))
  const { address, extraSegments } = parseAddress(text)

  useEffect(() => {
    if (canonical(text) !== formatAddress(value)) setText(formatAddress(value))
  }, [value])

  const handleChange = (event, { value: newText }) => {
    setText(newText)
    change(mergeAddress(value, parseAddress(newText).address))
  }

  const label = I18n.t(`${translationScope}.${underscored(name)}`, { defaultValue: 'Billing address' })

  return (
    <Form.Field>
      <label>{label}{required ? '*' : null}</label>
      <TextArea
        rows={2}
        value={text}
        disabled={readonly}
        onChange={handleChange}
        placeholder="Kerkstraat ; 12 ; 3 ; 9000 ; Gent ; BE"
      />
      <div style={{ marginTop: 6 }}>
        {ADDRESS_KEYS.map((key) => (
          <Label key={key} basic size="small" color={address[key] ? undefined : 'grey'}>
            {LABELS[key]}
            <Label.Detail>{address[key] || '—'}</Label.Detail>
          </Label>
        ))}
        {extraSegments.length > 0 && (
          <Label color="orange" size="small">
            Too many ';' — ignored: {extraSegments.join(' ; ')}
          </Label>
        )}
      </div>
    </Form.Field>
  )
}

const fieldModel = (ownProps) => `${ownProps.model || ''}.${ownProps.name}`

const mapStateToProps = (state, ownProps) => ({
  value: dotProp.get(state, fieldModel(ownProps))
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  change: (newValue) => dispatch(formActions.change(fieldModel(ownProps), newValue))
})

export default connect(mapStateToProps, mapDispatchToProps)(AddressPasteField)
